import React from 'react';
import { Form } from 'formik';

import Popup from '../Popup/Popup';

import styles from './PopupForm.module.scss';

interface Props {
  children?: React.ReactNode[];
  className?: string;
  closable?: boolean;
  darkenBg?: boolean;

  close?(): void;
}

const PopupForm = ({
  children,
  className,
  closable,
  darkenBg,
  close,
}: Props) => (
  <Popup
    width="420px"
    height="auto"
    close={close}
    closable={closable}
    darkenBg={darkenBg}
  >
    <Form className={`${styles.popup_form} ${className}`}>{children}</Form>
  </Popup>
);

PopupForm.defaultProps = {
  children: [],
  className: '',
  closable: false,
  darkenBg: true,
  close: () => {},
};

export default PopupForm;
